export enum PageName {
  PDP = "PDP",
  BRAND = "BRAND",
  GTM_PDP = "GTM_PDP",
  GTM_BRAND = "GTM_BRAND",
  INVOICE = "INVOICE",
  ORDER = "ORDER",
}

export const TOAST_AUTO_DISMISS_TIME_MS = 2000;

export const VIEW_COUNT_BEFORE_SILENCING_GTM = 5;
